// Datas "só dia" (AAAA-MM-DD) vindas do backend. Não usar new Date("AAAA-MM-DD"):
// isso interpreta como UTC e, no Brasil, mostra o dia anterior.
export const parseDateOnly = (value) => {
  if (!value) return null;
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value));
  if (!match) return null;
  const [, y, m, d] = match.map(Number);
  return new Date(y, m - 1, d);
};

// "outubro de 2025" — usa o campo manual e, sem ele, a data de cadastro
export const formatCustomerSince = (contact) => {
  if (!contact) return "";
  const date = contact.customerSince
    ? parseDateOnly(contact.customerSince)
    : contact.createdAt
    ? new Date(contact.createdAt)
    : null;
  if (!date || Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("pt-BR", { month: "long", year: "numeric" });
};

const isLeapYear = (year) =>
  (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;

// aniversário deste ano (29/02 vira 28/02 em ano não bissexto)
const birthdayInYear = (birth, year) => {
  const day =
    birth.getMonth() === 1 && birth.getDate() === 29 && !isLeapYear(year)
      ? 28
      : birth.getDate();
  return new Date(year, birth.getMonth(), day);
};

/**
 * Dados do aniversário para a ficha: "12/03", idade e quantos dias faltam
 * (0 = hoje). Retorna null se não houver data.
 */
export const getBirthdayInfo = (birthDate, today = new Date()) => {
  const birth = parseDateOnly(birthDate);
  if (!birth) return null;

  const start = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  let next = birthdayInYear(birth, start.getFullYear());
  if (next < start) next = birthdayInYear(birth, start.getFullYear() + 1);

  const daysUntil = Math.round((next - start) / 86400000);
  // idade que a pessoa tem hoje
  const age = next.getFullYear() - birth.getFullYear() - (daysUntil === 0 ? 0 : 1);

  return {
    label: birth.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" }),
    age: age >= 0 ? age : null,
    daysUntil,
  };
};
